import { BookingSourcesLabels } from "@obby/constants";

export function Booking__Source(booking: any): string {
  if (booking.bookingType === "private") return "Private";
  return BookingSourcesLabels[booking.source];
}
